import { useState, useRef } from 'react';

export function useEcadSnapping() {
  const [autoSnapEnabled, setAutoSnapEnabled] = useState(true);
  const [snappedRect, setSnappedRect] = useState<{ x: number, y: number, w: number, h: number, rx: number } | null>(null);
  
  const lastSnappedElementRef = useRef<HTMLElement | null>(null);
  const iframeObstaclesRef = useRef<Array<{ x: number, y: number, w: number, h: number, id: string }>>([]);

  const getControlAncestor = (el: HTMLElement | null): HTMLElement | null => {
    if (!el) return null;
    const control = el.closest('button, input, select, textarea, a, [role="button"], [role="link"]') as HTMLElement;
    if (control) return control;
    
    let cur: HTMLElement | null = el;
    while (cur && cur !== cur.ownerDocument.body) {
      if (cur.className && typeof cur.className === 'string') {
        const cls = cur.className.toLowerCase();
        if (cls.includes('btn') || cls.includes('button') || cls.includes('input-') || cls.includes('select-')) {
          return cur;
        }
      }
      cur = cur.parentElement;
    }
    return null;
  };

  const getCleanSelector = (el: HTMLElement): string => {
    try {
      if (el.id) return `#${el.id}`;
      if (el.className && typeof el.className === 'string') {
        const firstClass = el.className.split(' ')[0];
        if (firstClass && typeof firstClass === 'string' && !firstClass.includes(':')) {
          return `.${firstClass}`;
        }
      }
      return el.tagName.toLowerCase();
    } catch (e) {
      return 'el';
    }
  };

  return {
    autoSnapEnabled,
    setAutoSnapEnabled,
    snappedRect,
    setSnappedRect,
    lastSnappedElementRef,
    iframeObstaclesRef,
    getControlAncestor,
    getCleanSelector
  };
}
